// src/components/StatsSection.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaHome, FaUsers, FaBox, FaHandshake } from "react-icons/fa";
import CountUp from "react-countup";
import "./StatsSection.css"; // Custom CSS

const stats = [
  {
    id: 1,
    icon: <FaHome />,
    number: 300,
    suffix: "+",
    label: "Successfully Projects",
  },
  {
    id: 2,
    icon: <FaUsers />,
    number: 450,
    suffix: "+",
    label: "Company Staffs",
  },
  {
    id: 3,
    icon: <FaBox />,
    number: 3150,
    label: "Tons of Products",
  },
  {
    id: 4,
    icon: <FaHandshake />,
    number: 6561,
    label: "Satisfied Clients",
  },
];

const StatsSection = () => {
  return (
    <section className="stats-section py-5">
      <Container>
        <Row className="text-center">
          {stats.map((item) => (
            <Col md={3} sm={6} key={item.id} className="mb-4">
              <div className="stat-item">
                <div className="stat-icon">{item.icon}</div>
                <h3 className="stat-number">
                  <CountUp end={item.number} duration={3} separator="," />
                  {item.suffix}
                </h3>
                <p className="stat-label">{item.label}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default StatsSection;
